import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LocalizationService } from '@app/components/internationalization/localization.service';
import { UserService } from '../user/user.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private _authService: AuthService, private _userService: UserService, private _router: Router,  private _localizationService: LocalizationService) { };

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

      const isAuthenticated = await this._authService.getTokenFromStorage();
      if (isAuthenticated) {
        return true;
      }
      else {
        await this._authService.logout().then(() => {
          this._router.navigate(['login']);
        });
        return false;
      }

  }
}
